<app-hero-banner
  [title]="'privacy policy'"
  [isFullBanner]="false"
  [imgPath]="'../../../assets/hi-res/hero-half.JPG'"
></app-hero-banner>

<div class="privacy-policy-container">
  <h1>Privacy Policy</h1>
  <p>Last Updated: October 30, 2024</p>

  <!-- Introduction Section -->
  <section id="introduction">
    <h2>Bourne Bespoke Privacy Policy</h2>
    <p>
      This privacy policy explains how Bourne Bespoke uses the personal data we
      collect from you when you use our website.
    </p>
  </section>

  <!-- Topics Section -->
  <section id="topics">
    <h3>Topics:</h3>
    <ul>
      <li>What data do we collect?</li>
      <li>How do we collect your data?</li>
      <li>How will we use your data?</li>
      <li>How do we store your data?</li>
      <li>Marketing</li>
      <li>Your data protection rights</li>
      <li>What are cookies?</li>
      <li>How do we use cookies?</li>
      <li>Types of cookies we use</li>
      <li>How to manage cookies</li>
      <li>Privacy policies of other websites</li>
      <li>Changes to our privacy policy</li>
      <li>How to contact us</li>
      <li>How to contact the appropriate authorities</li>
    </ul>
  </section>

  <!-- Data Collected -->
  <section id="data-collected">
    <h2>What Data Do We Collect?</h2>
    <p>Bourne Bespoke collects the following data:</p>
    <ul>
      <li>
        Personal identification information (Name, email address, phone number,
        location, and uploaded images, up to 3 images).
      </li>
    </ul>
  </section>

  <!-- How Data is Collected -->
  <section id="data-collection">
    <h2>How Do We Collect Your Data?</h2>
    <p>
      You directly provide Bourne Bespoke with most of the data we collect. We
      collect data and process it when you:
    </p>
    <ul>
      <li>
        Provide and submit data via our contact form, including name, email,
        phone, location, service description, and uploaded images.
      </li>
      <li>Use or view our website via your browser’s cookies.</li>
    </ul>
    <p>
      Bourne Bespoke may also receive your data indirectly from the following
      sources:
    </p>
    <ul>
      <li>Google Analytics</li>
    </ul>
  </section>

  <!-- How We Use Data -->
  <section id="data-usage">
    <h2>How Will We Use Your Data?</h2>
    <p>Bourne Bespoke collects your data so that we can:</p>
    <ul>
      <li>Respond to your email enquiry regarding our services.</li>
      <li>
        Analyze website usage to improve user experience through Google
        Analytics.
      </li>
    </ul>
  </section>

  <!-- How We Store Data -->
  <section id="data-storage">
    <h2>How Do We Store Your Data?</h2>
    <p>
      Bourne Bespoke securely stores your images on our servers for 45 days
      before they are permanently deleted. We retain other personal data (such
      as name, email, and phone) as long as necessary to contact you regarding
      your enquiry or as required by applicable law.
    </p>
  </section>

  <!-- Marketing Section -->
  <section id="marketing">
    <h2>Marketing</h2>
    <p>
      Bourne Bespoke does not use your data to send you information about
      products and services.
    </p>
  </section>

  <!-- Data Protection Rights -->
  <section id="data-rights">
    <h2>Your Data Protection Rights</h2>
    <p>
      Bourne Bespoke wants to ensure you are fully aware of all of your data
      protection rights. Every user is entitled to the following:
    </p>
    <ul>
      <li>
        <strong>The right to access</strong> – You have the right to request
        copies of your personal data from Bourne Bespoke.
      </li>
      <li>
        <strong>The right to rectification</strong> – You have the right to
        request that Bourne Bespoke correct any information you believe is
        inaccurate or incomplete.
      </li>
      <li>
        <strong>The right to erasure</strong> – You have the right to request
        that Bourne Bespoke erase your personal data, under certain conditions.
      </li>
      <li>
        <strong>The right to restrict processing</strong> – You have the right
        to request that Bourne Bespoke restrict the processing of your personal
        data, under certain conditions.
      </li>
      <li>
        <strong>The right to object to processing</strong> – You have the right
        to object to Bourne Bespoke’s processing of your personal data, under
        certain conditions.
      </li>
      <li>
        <strong>The right to data portability</strong> – You have the right to
        request that Bourne Bespoke transfer the data that we have collected to
        another organization, or directly to you, under certain conditions.
      </li>
    </ul>
    <p>
      If you make a request, we have one month to respond to you. If you would
      like to exercise any of these rights, please contact us at our email:
      privacy&#64;prodigydesign.co.uk
    </p>
  </section>

  <!-- Cookies Section -->
  <section id="cookies">
    <h2>What Are Cookies?</h2>
    <p>
      Cookies are text files placed on your computer to collect standard
      Internet log information and visitor behavior information. When you visit
      our website, we may collect information from you automatically through
      cookies or similar technology. For further information, visit
      <a href="https://www.allaboutcookies.org">allaboutcookies.org</a>.
    </p>
  </section>

  <!-- How We Use Cookies -->
  <section id="cookie-usage">
    <h2>How Do We Use Cookies?</h2>
    <p>
      Bourne Bespoke uses cookies to improve your experience on our website by:
    </p>
    <ul>
      <li>Understanding how you use our website.</li>
      <li>Creating a smoother user experience.</li>
    </ul>
  </section>

  <!-- Types of Cookies Used -->
  <section id="cookie-types">
    <h2>What Types of Cookies Do We Use?</h2>
    <p>Bourne Bespoke uses the following types of cookies:</p>
    <ul>
      <li>
        <strong>Functionality</strong> – Bourne Bespoke uses these cookies to
        recognize you on our website and remember your previously selected
        preferences (such as language and location). Both first-party and
        third-party cookies are used.
      </li>
    </ul>
  </section>

  <!-- Managing Cookies -->
  <section id="manage-cookies">
    <h2>How to Manage Cookies</h2>
    <p>
      You can set your browser not to accept cookies, and
      <a href="https://www.allaboutcookies.org">allaboutcookies.org</a> will
      show you how to remove cookies from your browser. However, in a few cases,
      some website features may not function as a result.
    </p>
  </section>

  <!-- Other Website Privacy Policies -->
  <section id="external-privacy">
    <h2>Privacy Policies of Other Websites</h2>
    <p>
      The Bourne Bespoke website contains links to other websites. Our privacy
      policy applies only to our website, so if you click on a link to another
      website, you should read their privacy policy.
    </p>
  </section>

  <!-- Changes to Privacy Policy -->
  <section id="policy-changes">
    <h2>Changes to Our Privacy Policy</h2>
    <p>
      Bourne Bespoke keeps its privacy policy under regular review and places
      any updates on this web page. This privacy policy was last updated on
      October 30, 2024.
    </p>
  </section>

  <!-- Contact Us -->
  <section id="contact-us">
    <h2>How to Contact Us</h2>
    <p>
      If you have any questions about Bourne Bespoke’s privacy policy, the data
      we hold on you, or if you would like to exercise one of your data
      protection rights, please do not hesitate to contact us.
    </p>
    <p>Email us at: info&#64;prodigydesign.co.uk</p>
  </section>
</div>
